import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import LinkButton from 'flarum/common/components/LinkButton';

// Liens externes secondaires déplacés du header vers la sidebar de l'accueil.
// Voir docs/plans/2026-06-05-header-declutter-nav-design.md
const LINKS = [
    { id: 'ludo', icon: 'fas fa-lightbulb', href: 'https://ludotheque-imaginaire.fr', label: 'Ludothèque' },
    { id: 'ftd', icon: 'fas fa-theater-masks', href: 'https://www.forthedrama.com', label: 'For the drama' },
    { id: 'blog', icon: 'fas fa-paper-plane', href: 'https://www.cestpasdujdr.fr', label: 'Blog' },
    { id: 'archives', icon: 'fas fa-book', href: 'https://archives.cestpasdujdr.fr/', label: 'Archives' },
    { id: 'cpdjdr', icon: 'fas fa-dice-d20', href: 'https://www.cestpasdujdr.fr/', label: "C'est pas du JDR" },
];

export function addNavLinks() {
    extend(IndexPage.prototype, 'navItems', function (items) {
        LINKS.forEach((link, i) => {
            items.add(
                link.id,
                <LinkButton icon={link.icon} href={link.href} external={true} target="_blank">
                    {link.label}
                </LinkButton>,
                // Sous « Toutes les discussions » (100), au-dessus des tags.
                90 - i
            );
        });
    });
}
